import { Injectable } from '@angular/core';

import { Decimal } from 'decimal.js';

import { BetAndGetToken, CriteriaType, OddsBoostToken, RiskFreeToken } from '../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class MinimumStakeValidator extends TokensCriteriaValidatorBase<BetAndGetToken | OddsBoostToken | RiskFreeToken, CriteriaType> {
    override type = CriteriaType.MinimumStake;

    isValid(token: BetAndGetToken | OddsBoostToken | RiskFreeToken, state: TokenValidationInput): boolean {
        if (!token.minimumStake) {
            return true;
        }
        const currentStake = state.stake;

        if (!currentStake) {
            return false;
        }

        const minimumStake = new Decimal(token.minimumStake);

        return new Decimal(minimumStake).lessThanOrEqualTo(currentStake);
    }
}
